import { Chips } from 'primereact/chips'
import './InputEmails.scss'

const InputEmails = (props: {
    id: string
    max?: number
    value: string[]
    placeholder: string
    setValue: (value: string[]) => void
}) => {
    const { id, max, value, placeholder, setValue } = props

    const componentClass = 'smart-wardrobe-input-emails'

    const regex = new RegExp(/(.+)@(.+){2,}\.(.+){2,}/)

    const onBlur = () => {
        let input = document.getElementById(id) as HTMLInputElement
        let inputValue = input.value
        if (regex.test(inputValue)) {
            setValue([...value, inputValue])
        }
        input.value = ''
    }

    const onChange = (newEmails: string[]) => {
        let tmpEmails: string[] = []
        if (newEmails?.length > 0) {
            newEmails.map((newEmail: string) => {
                if (regex.test(newEmail)) {
                    tmpEmails.push(newEmail)
                }
            })
        }
        setValue(tmpEmails)
    }

    return (
        <div className={componentClass}>
            <Chips
                inputId={id}
                separator=","
                value={value}
                onBlur={onBlur}
                max={max || undefined}
                onChange={(e: any) => onChange(e.value)}
                placeholder={value?.length > 0 ? '' : placeholder}
            />
        </div>
    )
}

export default InputEmails
